import React from "react";

import { framework_tool, component_tool } from "@/tool";
import Editor from './editor'
const { WizModal } = component_tool
import HighSet from "@/containers/common/highSet";
//配置项
let componentName = "certStage";
const columns = (self) => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    //搜索字段
    {
      title: "证书名称",
      name: "searchCertName",
      dataIndex: "searchCertName",
      searchItem: {},
    },
    {
      title: "证书分类",
      name: "searchCertCategoryName",
      dataIndex: "searchCertCategoryName",
      searchItem: {},
    },
    {
      title: "路径名称",
      name: "searchPathName",
      dataIndex: "searchPathName",
      searchItem: {},
    },
    {
      title: "路径阶段",
      name: "searchStageName",
      dataIndex: "searchStageName",
      searchItem: {},
    },

    //列表展示字段
    {
      title: "证书名称",
      name: "certName",
      tableItem: {
      },
    },
    {
      title: "证书分类",
      name: "certCategoryName",
      tableItem: {
      },
    },
    {
      title: "路径名称",
      name: "pathName",
      tableItem: {
      },
    },
    {
      title: "路径阶段",
      name: "stageName",
      tableItem: {
      },
    },
    {
      title: "状态",
      name: "status",
      dataIndex: "status",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '启用'},
      ]
    },
  ];
};

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            function filter(value) {
              for (let key in value) {
                if (value[key] === undefined) {
                  delete value[key];
                } else if (Object.prototype.toString.call(value[key])==='[object Object]') {
                  filter(value[key])
                }
              }
            }
            filter(value);
            return value
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey:'editorAdd',
                  modalParams: {
                    title: '新增',
                    style: { minWidth: 700 },
                    diy: (e) => {
                      let editorProps = {
                        key: new Date().getTime(),
                        ref: r => r && r.getWrappedInstance(),
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ["enableOrDisable", 'advancedSet'],
        rowOperateView: [
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'status',
              dirt: {0: '启用',1: '禁用'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let statusNameStr= record['status'] === 0 ? "启用" : "禁用";
                const content = `您确定要`+statusNameStr+`该认证路径阶段配置吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ...record,
                      status:  record['status'] === 0 ? 1 : 0,
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{record: e.record,bizType: 52}} //证书路径阶段管理权限
                               changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
          },
        ],
        commonOperate: {}
      },
    },
  };
};

const apis = () => {
  return {
    list: {
      path: `${componentName}/getPageList`,
      payload: {
        key: `${componentName}@getPageList`,
        apiParams: { },
      },
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {},
      },
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {},
      },
    },
    updateState: {
      path: `${componentName}/updateState`,
      payload: {
        key: `${componentName}@updateState`,
        apiParams: {},
      },
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {},
      },
    },
    getOneInfo: {
      path: `${componentName}/getOneInfo`,
      payload: {
        key: `${componentName}@getOneInfo`,
        apiParams: {},
      },
    },
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
